import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { useAppToast } from '@ui-seeker/app'
import { isEmpty, postSubmit } from '@ui-seeker/utils'

import { BACKEND_APIS } from '@constants'
import { skuGroupUserModalFilters, reloadSkuGroupFilters } from '../@signals'


export default function SkuGroupUserModal() {
    const { showToast } = useAppToast()

    const isOpen = !isEmpty(skuGroupUserModalFilters.value)
    const { userID, userName, customerID, groupIDs = [] } = skuGroupUserModalFilters.value

    const handleClose = () => {
        skuGroupUserModalFilters.value = {}
    }

    const handleSave = () => {
        showToast.promise(
            postSubmit(`${BACKEND_APIS.MANAGEMENT}/sku-group/sync-groups`, {
                userID,
                groupIDs,
            }).then(() => {
                reloadSkuGroupFilters.value += 1
                handleClose()
            })
        )
    }

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Manage SKU Groups — {userName}</DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                {isOpen && <AutocompleteAjaxSeeker
                    urlAjax={`${BACKEND_APIS.MANAGEMENT}/sku-group/group-options`}
                    filters={{ customerID }}
                    label="SKU Groups"
                    placeholder="Search groups..."
                    multiple
                    value={groupIDs}
                    onChange={e => {
                        skuGroupUserModalFilters.value = {
                            ...skuGroupUserModalFilters.value,
                            groupIDs: e.target.value,
                        }
                    }}
                    sx={{ mt: 1 }}
                />}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    )
}
